import {
    GET_CONSULTANTS,
    GET_CONSULTANT_PROJECTS,
    UPDATE_PROJECT_TIME,
    GET_PROJECT_ACTIVITIES,
    GET_PUBLIC_HOLIDAYS,
    ERROR,
    START_LOADING,
    STOP_LOADING
} from '../TimeAction/types';

const INITIAL_STATE = {
    loading: false,
    success: false,
    consultants_list: [],
    consultant_projects: [],
    project_time: null,
    project_activities: [],
    public_holidays: [],
    error_message: ''
}

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case GET_CONSULTANTS:
            return {
                ...state,
                consultants_list: action.payload,
                success: false
            }
        case GET_CONSULTANT_PROJECTS:
            return {
                ...state,
                consultant_projects: action.payload,
            }
        case UPDATE_PROJECT_TIME: {
            return {
                ...state,
                project_time: action.payload,
                success: true
            }
        }
        case GET_PROJECT_ACTIVITIES:
            return {
                ...state,
                project_activities: action.payload,
                success: false
            }
        case GET_PUBLIC_HOLIDAYS:
            return {
                ...state,
                public_holidays: action.payload,
                success: false
            }
        case START_LOADING:
            return {
                ...state,
                loading: true
            }
        case STOP_LOADING:
            return {
                ...state,
                loading: false
            }
        case ERROR:
            return {
                ...state,
                error_message: action.payload,
                loading: false
            }
        default:
            return {
                ...state
            }
    }
}